/**
 * Emit a development-only console warning. Suppressed when the consuming
 * bundler replaces `process.env.NODE_ENV` with `"production"` (Vite, webpack,
 * Rollup, esbuild all do this), so end users do not see the message.
 *
 * `process` is declared locally so this package does not need `@types/node`.
 */
declare const process:
  | { env?: { NODE_ENV?: string } }
  | undefined;

export function devWarn(message: string): void {
  if (typeof process !== 'undefined' && process?.env?.NODE_ENV === 'production') {
    return;
  }
  console.warn(`[@aibuild/ui] ${message}`);
}
